import React from 'react';
import './App.css';

export default function Crops({ onBackClick, onNavigate }) {
    const categories = [
        { id: 'paddy', title: 'වී වගාව', icon: '🌾' },
        { id: 'vegetables', title: 'එළවළු වගාව', icon: '🥦' },
        { id: 'fruits', title: 'පලතුරු වගාව', icon: '🍎' },
        { id: 'ofc', title: 'අතිරේක ආහාර බෝග', icon: '🌽' },
        { id: 'roots', title: 'අල වගාව', icon: '🥔' }
    ];

    return (
        <main className="about-overview-container" style={{ padding: '20px 16px' }}>
            <div style={{ maxWidth: 1100, margin: '0 auto', width: '100%', marginBottom: '20px' }}>
                <button
                    className="back-button"
                    onClick={() => onBackClick && onBackClick('home')}
                    style={{
                        backgroundColor: '#0b6b2f',
                        color: 'white',
                        border: 'none',
                        padding: '8px 16px',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontSize: '14px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px'
                    }}
                >
                    ← ආපසු
                </button>
            </div>

            <div className="about-overview-inner" style={{ display: 'block' }}>
                <div className="about-overview-content" style={{ maxWidth: '1100px', margin: '0 auto', width: '100%' }}>
                    <div style={{ textAlign: 'center', marginBottom: '40px' }}>
                        <h1 className="about-overview-title" style={{ fontSize: 'clamp(24px, 5vw, 32px)', marginBottom: '10px', textAlign: 'justify' }}>බෝග නිෂ්පාදනය</h1>
                        <div style={{ height: '4px', maxWidth: '100%', width: '100%', background: '#0b6b2f', margin: '0 auto', borderRadius: '2px' }}></div>
                    </div>

                    <div className="crops-grid" style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(clamp(250px, 80vw, 320px), 1fr))',
                        gap: '24px',
                        padding: '10px 0'
                    }}>
                        {categories.map((cat) => (
                            <div key={cat.id}
                                className="crop-cat-card"
                                onClick={() => {
                                    const pageId = cat.id === 'paddy' ? 'wee' : `crop-${cat.id}`;
                                    onNavigate(pageId);
                                    try { window.history.replaceState({}, '', window.location.pathname + `?page=${pageId}`); } catch (err) { }
                                }}
                                style={{
                                    background: '#fff',
                                    borderRadius: '16px',
                                    padding: 'clamp(20px, 5vw, 32px) clamp(15px, 3vw, 24px)',
                                    textAlign: 'center',
                                    boxShadow: '0 10px 25px rgba(0,0,0,0.06)',
                                    border: '1px solid #eee',
                                    transition: 'all 0.3s ease',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    gap: '16px'
                                }}
                                onMouseOver={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-8px)';
                                    e.currentTarget.style.boxShadow = '0 15px 35px rgba(11, 107, 47, 0.12)';
                                    e.currentTarget.style.borderColor = '#0b6b2f';
                                }}
                                onMouseOut={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 10px 25px rgba(0,0,0,0.06)';
                                    e.currentTarget.style.borderColor = '#eee';
                                }}
                            >
                                <div style={{
                                    fontSize: 'clamp(40px, 10vw, 56px)',
                                    background: '#f0f9f4',
                                    width: 'clamp(80px, 15vw, 100px)',
                                    height: 'clamp(80px, 15vw, 100px)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    borderRadius: '50%',
                                    marginBottom: '8px'
                                }}>
                                    {cat.icon}
                                </div>
                                <h3 style={{ color: '#0b6b2f', margin: 0, fontSize: '22px', fontWeight: '700' }}>{cat.title}</h3>
                                <p style={{ color: '#666', fontSize: '14px', margin: 0 }}>වගා තොරතුරු සහ සංඛ්‍යාලේඛන සඳහා පිවිසෙන්න</p>
                                <button style={{
                                    marginTop: '8px',
                                    padding: '8px 24px',
                                    background: '#0b6b2f',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: '25px',
                                    fontSize: '14px',
                                    fontWeight: '600',
                                    cursor: 'pointer'
                                }}>තවත් විස්තර</button>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </main>
    );
}
